import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  IconButton,
  Grow,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import { ProfessionalTitleRepository } from "./ProfessionalTitleRepository";
import {
  professionalTitleValidator,
  professionalTitlePointsValidator,
} from "./ProfessionalTitleValidator";
import GradingCommentComponent from "./GradingCommentComponent";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles(styles);

export default function ProfessionalTitleComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [professionalTitleTypes, setProfessionalTitleTypes] = React.useState();
  const [professionalTitleAreas, setProfessionalTitleAreas] = React.useState();

  const [rerender, triggerRerender] = React.useState(false);
  const [professionalTitleData, setProfessionalTitleData] = React.useState([]);
  const [professionalTitleDataFormErrors, setProfessionalTitleDataFormErrors] =
    React.useState({});
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();

  useEffect(() => {
    triggerRerender(!rerender);
  }, [professionalTitleDataFormErrors]);

  useEffect(() => {
    ProfessionalTitleRepository.getAllAreas(props.gradingSchemaId).then(
      (res) => {
        setProfessionalTitleAreas(res.data);
      }
    );
    ProfessionalTitleRepository.getAllTypes(props.gradingSchemaId).then(
      (res) => {
        setProfessionalTitleTypes(res.data);
      }
    );
    ProfessionalTitleRepository.getProfessionalTitleData(
      props.vacancyAppId
    ).then(
      (res) => {
        if (res.data.length > 0) setProfessionalTitleData(res.data);
      },
      (err) => {}
    );
  }, []);

  const addRow = () => {
    let data = professionalTitleData;
    data.push({
      type: { id: "" },
      area: { id: "" },
      proofs: [],
    });
    setProfessionalTitleData(data);
    setProfessionalTitleDataFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = professionalTitleData;
    data.splice(index, 1);
    setProfessionalTitleData(data);
    setProfessionalTitleDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = (event, index, name) => {
    let data = professionalTitleData;
    if (name == "type" || name == "area") {
      data[index][name]["id"] = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setProfessionalTitleData(data);
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = professionalTitleData;
    data[index][name] = date;
    setProfessionalTitleData(data);
    triggerRerender(!rerender);
  };

  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = professionalTitleData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalTitleValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalTitleValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalTitleDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = professionalTitleData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalTitleValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalTitleValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalTitleDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    ProfessionalTitleRepository.saveProfessionalTitleData(
      props.vacancyAppId,
      professionalTitleData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = professionalTitleData;
    data[index].proofs = attachments;
    setProfessionalTitleData(data);
  };

  const changePoints = (item) => {
    ProfessionalTitleRepository.updatePoints(item.id, item.points).then(
      (res) => {
        ProfessionalTitleRepository.getProfessionalTitleData(
          props.vacancyAppId
        ).then(
          (res) => {
            if (res.data.length > 0) {
              setProfessionalTitleData(res.data);
              setProfessionalTitleDataFormErrors({});
              triggerRerender(!rerender);
            }
          },
          (err) => {}
        );
      }
    );
  };

  const unlockPoints = (item) => {
    ProfessionalTitleRepository.unlockPoints(item.id).then((res) => {
      ProfessionalTitleRepository.getProfessionalTitleData(
        props.vacancyAppId
      ).then(
        (res) => {
          if (res.data.length > 0) {
            setProfessionalTitleData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!professionalTitlePointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "professional_title");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await professionalTitlePointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setProfessionalTitleDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      ProfessionalTitleRepository.setComment(item.id, item.comment).then(
        (res) => {
          let tmp = professionalTitleData;
          tmp[index] = item;
          setProfessionalTitleData(tmp);
          triggerRerender(!rerender);
          setShowCommentDialog(false);
        }
      );
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle>{LOCALE.professional_title_info_title}</AlertTitle>

          {LOCALE.professional_title_info_description}
        </Alert>
      )}
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>{LOCALE.professional_title}</Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <Button
                  color="default"
                  variant="contained"
                  className={
                    professionalTitleData.length == 0 ? "bounceButton" : ""
                  }
                  startIcon={<Icon>add_circle_outline</Icon>}
                  size="small"
                  aria-label="create"
                  style={{ float: "right" }}
                  onClick={addRow}
                >
                  {LOCALE.add_professional_title}
                </Button>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.professional_title_type}
                </TableCell>
                <TableCell
                  style={{ textTransform: "capitalize" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.domain}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {professionalTitleData.length > 0 ? (
                professionalTitleData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>

                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.type.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          variant="outlined"
                          error={
                            professionalTitleDataFormErrors[index] &&
                            professionalTitleDataFormErrors[index]["type.id"]
                          }
                          size="small"
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.professional_title_type}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.professional_title_type}
                            value={item.type.id}
                            onChange={(e) => handleChange(e, index, "type")}
                          >
                            {professionalTitleTypes?.map((item, index) => (
                              <MenuItem key={index} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {professionalTitleDataFormErrors[index] &&
                              professionalTitleDataFormErrors[index]["type.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.area.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          style={{ width: "250px" }}
                          variant="outlined"
                          error={
                            professionalTitleDataFormErrors[index] &&
                            professionalTitleDataFormErrors[index]["area.id"]
                          }
                          size="small"
                        >
                          <InputLabel
                            id="demo-simple-select-label"
                            style={{ textTransform: "capitalize" }}
                          >
                            {LOCALE.domain}
                          </InputLabel>
                          <Select
                            style={{ textTransform: "capitalize" }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.domain}
                            value={item.area.id}
                            onChange={(e) => handleChange(e, index, "area")}
                          >
                            {professionalTitleAreas?.map((item, index) => (
                              <MenuItem key={index} value={item.id}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {professionalTitleDataFormErrors[index] &&
                              professionalTitleDataFormErrors[index]["area.id"]
                                ?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        disabled={props.disabled}
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          professionalTitleDataFormErrors[index] &&
                          professionalTitleDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"PROFESSIONAL_TITLE"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {professionalTitleDataFormErrors[index] &&
                            professionalTitleDataFormErrors[index]["proofs"]
                              ?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status == "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            professionalTitleDataFormErrors[index] &&
                            professionalTitleDataFormErrors[index][
                              "pointsChecked"
                            ]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label="Поени"
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "6px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "6px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {professionalTitleDataFormErrors[index] &&
                              professionalTitleDataFormErrors[index][
                                "pointsChecked"
                              ]?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>{" "}
                    {LOCALE.no_professional_titles_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            disabled={btnDisabled}
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(professionalTitleData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status === "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
  );
}
